import { render } from "./index.vue?vue&type=template&id=71617b16"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/permission-denied/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71617b16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71617b16', __exports__)) {
    api.reload('71617b16', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=71617b16", () => {
    api.rerender('71617b16', render)
  })

}


export default __exports__